// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2qu6t","label":"styles_label__8Mf_A"};